import { useNode } from '@craftjs/core';
import {
  AnswersPanel,
  LayoutPanel,
  LogicPanel,
  TextFieldPanel,
  TitlePanel,
  ValidationPanel,
} from 'src/features/generalForms/builder/layout/panels';
import { FormNumberInputComponent, FormNumberInputProps } from 'src/features/generalForms/builder/types/NumberInput';
import { useDataKeyValidation } from 'src/features/generalForms/builder/validationContext/helper';
import { AppTextField } from 'src/features/generalForms/uikit/fields/text/textField';

export const FormNumberInput: FormNumberInputComponent = (props) => {
  const {
    connectors,
    styles,
    actions: { setProp },
  } = useNode((node) => ({
    styles: node.data.custom,
  }));
  const { connect, drag } = connectors;
  const validationResult = useDataKeyValidation();

  return (
    <div ref={(ref: HTMLDivElement) => connect(drag(ref))} style={styles}>
      <AppTextField
        type={'number'}
        disabled={props.disabled}
        placeholder={props.placeholder}
        units={props.units}
        maxLength={props.maxLength}
        labelProps={{
          text: props.title,
          isBold: true,
          tooltip: props.tooltip,
          description: props.description,
          isOptional: props.isOptional,
          prefix: props.prefix,
        }}
        value={props.defaultValue || ''}
        onChange={(e) =>
          setProp((p: FormNumberInputProps) => {
            p.defaultValue = e.target.value;
          }, 500)
        }
        onBlur={(e) =>
          setProp((p: FormNumberInputProps) => {
            p.defaultValue = p.decimal !== undefined ? Number(e.target?.value).toFixed(p.decimal) : e.target?.value;
          }, 500)
        }
        errorProps={{ errors: validationResult?.message }}
      />
    </div>
  );
};

export const FormNumberInputSettings = () => (
  <>
    <TitlePanel sections={['Title', 'Description', 'Prefix', 'Tooltip', 'DataKey']} />
    <AnswersPanel sections={['NoAnswerScore']} />
    <TextFieldPanel sections={['Placeholder', 'Units', 'Decimal']} />
    <LayoutPanel sections={['Paddings']} />
    <ValidationPanel type={'number'} sections={['MinMax']} />
    <LogicPanel sections={['Visible', 'Enable']} />
  </>
);

FormNumberInput.craft = {
  displayName: 'Number',
  rules: { canDrag: () => true },
  related: { settings: FormNumberInputSettings },
};
